import { render } from "./SectionAuctions.vue?vue&type=template&id=091eed08&scoped=true"
import script from "./SectionAuctions.vue?vue&type=script&lang=js"
export * from "./SectionAuctions.vue?vue&type=script&lang=js"

import "./SectionAuctions.vue?vue&type=style&index=0&id=091eed08&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091eed08"]])

export default __exports__